import {createProjectModel} from 'crm/utils/project-model'
import {getJoinGroupWay, setJoinGroupWay} from './service'

const model = createProjectModel({
    projectNamespace: 'joinGroupWayModal',

    state: {},

    effects: {
        *getJoinGroupWay(xx, {call}) {
            return yield call(getJoinGroupWay)
        },

        *setJoinGroupWay({payload}, {call}) {
            return yield call(setJoinGroupWay, payload)
        },
    },
})

export default model
